export default __webpack_public_path__ + "static/media/kanime.cf9193dc.png";